module.exports = "<p>\r\n  Signing out ...\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/logout/logout.component.html
// module id = ./src/app/logout/logout.component.html
// module chunks = main